import jwtDecode from 'jwt-decode';
import http from './httpService';
import {apiUrl} from '../config.json';


const apiEndpoint = apiUrl + '/eusers/auth';
const tokenKey="token";

http.setJwt(getJwt());

export async function explogin(obj1){
   const {data:jwt}=await http.post(apiEndpoint,obj1);
   localStorage.setItem(tokenKey,jwt); 
}

export function loginWithJwt(jwt){
   localStorage.setItem(tokenKey,jwt);  
}

export function logout(){
   localStorage.removeItem(tokenKey);

}

export function getCurrentUser(){
   try{
      const jwt = localStorage.getItem(tokenKey);
      return jwtDecode(jwt);
     
    }
    catch(ex){
       return null;
    } 
   
}

export function getJwt(){
   return localStorage.getItem(tokenKey);
};

export default {
   explogin,
   loginWithJwt,
   logout,
   getCurrentUser,
   getJwt
};